import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { ProjectSettingsComponent } from "@core/projects/project-settings/project-settings.component";
import { IProjectSettings } from "@static/models/project";


@Component({
  selector: 'app-project-settings-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    ProjectSettingsComponent
  ],
  templateUrl: './project-settings-dialog.component.html',
  styleUrl: './project-settings-dialog.component.scss',
})
export class ProjectSettingsDialogComponent {
  public project = inject(MAT_DIALOG_DATA) as IProjectSettings;

  protected readonly dialogRef =
    inject(MatDialogRef<ProjectSettingsDialogComponent>);


  /**
   * Close the dialog
   */
  public close(): void {
    this.dialogRef.close();
  }
}

